<template>
  <div class="body">
    <el-row class="top">
      <el-col class="left" :span="8">
        <el-row>
          <el-col :span="8">&nbsp;</el-col>
          <el-col :span="8">
            <div class="makerLabel">
              <div class="text">{{ deviceInstantiationGroup?deviceInstantiationGroup.name:'未找到设备组' }}</div>
              <div class="icon"><img src="../../assets/dataV/xiasanjiao.png"/></div>
            </div>
          </el-col>
          <el-col :span="8">&nbsp;</el-col>
        </el-row>
      </el-col>
      <el-col class="middle" :span="8">{{ organization.name }}驾驶舱</el-col>
      <el-col class="right" :span="7">
        {{ timeStr }}
      </el-col>
      <el-col class="manager" :span="1">
        <div @click="jumpManage()">进入后台</div>
      </el-col>
    </el-row>
    <div class="content">
      <div class="left">
        <div class="t1" id="container"></div>
        <div class="t2">
          <div class="title">设备状态</div>
          <div class="table">
            <div class="table-header">
              <el-row>
                <el-col :span="6">位置</el-col>
                <el-col :span="12">设备</el-col>
                <el-col :span="6">状态</el-col>
              </el-row>
            </div>
            <div class="table-item" v-for="deviceInstantiation in deviceInstantiations" :key="deviceInstantiation.id" v-if="deviceInstantiation.perprotiesValues && deviceInstantiation.perprotiesValues.length > 0">
              <el-row>
                <el-col :span="6">{{ deviceInstantiationGroup.name }}</el-col>
                <el-col :span="12">{{ deviceInstantiation.name }}</el-col>
                <el-col :span="6">{{ deviceInstantiation.status }}</el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="t1">
          <div class="l">
            <div class="title">实时数据</div>
            <div class="datas">
              <div class="item" v-for="deviceInstantiation in deviceInstantiations" :key="deviceInstantiation.id" v-if="deviceInstantiation.perprotiesValues && deviceInstantiation.perprotiesValues.length > 0">
                <div class="fenge">{{ deviceInstantiation.name }}:</div>
                <div class="ps" :style="'height: ' + (Math.ceil(deviceInstantiation.perprotiesValues.length / 2) * 71) + 'px'">
                  <div class="data" v-for="perproty in deviceInstantiation.perprotiesValues" :key="perproty.id" >
                    <div class="c1">{{ perproty.name }}({{ perproty.status }})</div>
                    <div class="c2">{{ perproty.val }}{{ !perproty.property||!perproty.property.unit?'':perproty.property.unit }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="r">
            <div class="ct">
              <div class="title">实时监控</div>
              <div class="text" @click="playVideo(choseCameraUrl, choseCameraId, 'video-container-dialog')">全屏</div>
            </div>
            <div class="camera">
              <div id="video-container"></div>
            </div>
            <div class="camera-btns">
              <div :class="choseCameraId!=camera.id?'btn':'btnCur'" v-for="camera in cameras" :key="camera.id" @click="playVideo(camera.outNetUrl, camera.id, 'video-container')">{{ camera.name }}</div>
            </div>
          </div>
        </div>
        <div class="t2">
          <div class="title">数据分析</div>
          <div class="l">
            <div class="datas">
              <div class="item" v-for="deviceInstantiation in deviceInstantiations" :key="deviceInstantiation.id" v-if="deviceInstantiation.perprotiesValues && deviceInstantiation.perprotiesValues.length > 0">
                <div class="fenge">{{ deviceInstantiation.name }}:</div>
                <div class="ps">
                  <div class="data" v-for="perproty in deviceInstantiation.perprotiesValues" :key="perproty.id" v-if="perproty.property.dataType == 'integer' || perproty.property.dataType == 'float'">
                    <div class="btn" @click="queryUploadDataForStatByParamName(deviceInstantiation.id, perproty.paramName)" v-if="(deviceInstantiation.id+'_'+perproty.paramName) != chosePropertyName">{{ perproty.name }}</div>
                    <div class="btnCur" @click="queryUploadDataForStatByParamName(deviceInstantiation.id, perproty.paramName)" v-if="(deviceInstantiation.id+'_'+perproty.paramName) == chosePropertyName">{{ perproty.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="r" id="chart"></div>
        </div>
      </div>
    </div>
    <el-dialog title="实时监控" :visible.sync="dialogVisible" :before-close="handleDialogClose" width="1320px">
      <div id="video-container-dialog" style="width: 1280px; height: 720px;"></div>
    </el-dialog>      
  </div>
</template>

<script>
import requestService from '../../util/request'
import AMapLoader from '@amap/amap-jsapi-loader'
import CameraIcon from '../../assets/dataV/icon-jiankong.png'
import PestIcon from '../../assets/dataV/icon-pest.png'
import SenorIcon from '../../assets/dataV/icon-senor.png'
import BgKuang from '../../assets/dataV/kuang.png'
import { formatDate } from '../../util/date'
import * as echarts from 'echarts'
import EZUIKit from 'ezuikit-js'

export default {
  data () {
    return {
      chart: null,
      deviceInstantiationGroups: [],
      deviceInstantiationGroup: null,
      deviceInstantiations: [],
      deviceInstantiation: null,
      grounds: [],
      cameras: [],
      AMap: null,
      intervalTime: null,
      intervalDevices: null,
      timeStr: '',
      player: null,
      cameraAccessToken: null,
      intervalCameraAccessToken: null,
      statLogs: [],
      statDevice: null,
      organization: {},
      chosePropertyName: '',
      choseCameraId: '',
      choseCameraUrl: '',
      dialogVisible: false
    }
  },
  created () {
  },
  mounted () {
    this.loadOrg()
    this.initAMap()
    this.timeRefreshCameraAccessToken()
    this.intervalTime = setInterval(this.timeRefresh, 1000)
    this.intervalDevices = setInterval(this.timeRefreshDevices, 300000)
    this.intervalCameraAccessToken = setInterval(this.timeRefreshCameraAccessToken, 60000)
    this.chart = echarts.init(document.getElementById('chart'))
  },
  destroyed () {
    clearInterval(this.intervalTime)
    clearInterval(this.intervalDevices)
    clearInterval(this.intervalCameraAccessToken)
  },
  methods: {
    loadOrg () {
      let that = this
      this.deviceInstantiationGroups = []
      requestService.get('/organization/getOneMyOrg', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.organization = res.data.body
      })
    },
    playVideo (url, cameraId, cid) {
      if (this.player) {
        this.player.stop()
      }
      let width = 435
      let height = 260
      if (cid=='video-container-dialog') {
        this.dialogVisible = true
        width = 1280
        height = 720
      }
      this.choseCameraId = cameraId
      this.choseCameraUrl = url

      this.player = new EZUIKit.EZUIKitPlayer({
        id: cid,
        accessToken: this.cameraAccessToken,
        url: url,
        audio: 0,
        autoplay: true,
        width: width,
        height: height
      })
    }, 
    handleDialogClose () {
      this.player.stop()
      this.dialogVisible = false
      this.playVideo(this.choseCameraUrl, this.choseCameraId, 'video-container')
    },
    queryUploadDataForStatByParamName (deviceInstantiationId, paramName) {
      let that = this
      that.chosePropertyName = deviceInstantiationId + '_' + paramName
      if (that.statDevice.id === deviceInstantiationId && this.statLogs && this.statLogs.length>0) {
        let xData = []
        let yData = []
        for (let log of that.statLogs) {
          xData.push(that.formatDate(log.addTime, 'hh:mm'))
          let msg = JSON.parse(log.msg)
          yData.push(msg[paramName])
        }
        that.chart_init(xData, yData)
      }else{
        this.statLogs = []
        requestService.get(`/deviceInstantiationMsgLog/listUploadDataForStat?deviceInstantiationId=${deviceInstantiationId}&intervalTimeType=2`, {
        }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
          that.statLogs = res.data.body
          if (paramName) {
            let xData = []
            let yData = []
            for (let log of that.statLogs) {
              xData.push(that.formatDate(log.addTime, 'hh:mm'))
              let msg = JSON.parse(log.msg)
              yData.push(msg?(msg[paramName]?msg[paramName]:0):0)
            }
            that.chart_init(xData, yData)
          }
        })
      }
    },
    loadDeviceInstantiationGroups () {
      let that = this
      this.deviceInstantiationGroups = []
      requestService.get('/deviceInstantiationGroup/listPage?pageSize=65535', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceInstantiationGroups = res.data.body.records
        if (that.deviceInstantiationGroups && that.deviceInstantiationGroups.length > 0) {
          that.deviceInstantiationGroup = that.deviceInstantiationGroups[0]
          that.loadDeviceInstantiations(that.deviceInstantiationGroup.id)
          that.loadCamers(that.deviceInstantiationGroup.id)
        }
      })
    },
    loadDeviceInstantiations (deviceInstantiationGroupId) {
      let that = this
      this.deviceInstantiations = []
      requestService.get(`/deviceInstantiation/listPage?pageSize=65535&deviceInstantiationGroupId=${deviceInstantiationGroupId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceInstantiations = res.data.body.records
        if (that.deviceInstantiations && that.deviceInstantiations.length > 0) {
          that.deviceInstantiation = that.deviceInstantiations[0]

          for (let di of that.deviceInstantiations) {
            if (!that.statDevice) {
              for (let p of di.perprotiesValues) {
                if (p.property.dataType === 'integer' || p.property.dataType === 'float') {
                  that.statDevice = di
                  that.queryUploadDataForStatByParamName(di.id, p.property.paramName)
                  break
                }
              }
            }

            if (di.perprotiesValues) {
              di.status = '离线'
              for (let perproty of di.perprotiesValues) {
                if (perproty.status === '在线') {
                  di.status = '在线'
                  break
                }
              }
            }
            if (!di.lng || !di.lat) {
              continue
            }
            let position = new that.AMap.LngLat(di.lng, di.lat)
            let marker
            if (di.name.indexOf('虫') > -1) {
              marker = new that.AMap.Marker({
                position: position,
                offset: new that.AMap.Pixel(-8, -17),
                icon: PestIcon,
                deviceInstantiationId: di.id,
                deviceInstantiationName: di.name,
                label: {
                  direction: 'top',
                  content: di.name,
                }
              })              
            }else {
              marker = new that.AMap.Marker({
                position: position,
                offset: new that.AMap.Pixel(-8, -17),
                icon: SenorIcon,
                deviceInstantiationId: di.id,
                deviceInstantiationName: di.name,
                label: {
                  direction: 'top',
                  content: di.name,
                }
              })
            }
            marker.on("click", function (e) {
              var info = [];
              info.push("<div style='width:214px;height:207px;background: url("+BgKuang+") center center no-repeat;'>");
              info.push("<div style='color:#FFFFFF;line-height: 30px;padding-left:10px;letter-spacing: 1px;font-size:14px;'><b>传感器名:</b>"+di.name+"</div>");
              info.push("<div style='width:214px;height:177px;overflow-y: auto;scrollbar-width: none;'>");
              for (let p of di.perprotiesValues) {
                info.push("<div style='color:#F5F5F5;line-height: 16px;padding-left:10px;font-size:12px;'><b>"+p.name+":"+"</b>"+p.val+"("+p.status+")</div>");
              }
              info.push("</div>");
              info.push("</div>");
              that.infoWindow = new AMap.InfoWindow({
                  content: info.join(""),
                  isCustom: true
              });
              that.infoWindow.on('close', function (){ that.infoWindow.close() })
              that.infoWindow.open(that.map, marker.getPosition());              
            })
            that.map.add(marker)
          }
        }
      })
    },
    loadCamers (deviceInstantiationGroupId) {
      let that = this
      this.cameras = []
      requestService.get(`/camera/listPage?pageSize=65535&deviceInstantiationGroupId=${deviceInstantiationGroupId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.cameras = res.data.body.records
        if (!that.cameras || that.cameras.length === 0) {
          return
        }
        let flag = 0
        for (let camera of that.cameras) {
          if (camera.outNetUrl && flag === 0) {
            flag = 1
            that.playVideo(camera.outNetUrl, camera.id, 'video-container')
          }
          if (!camera.lng || !camera.lat) {
            continue
          }
          let position = new that.AMap.LngLat(camera.lng, camera.lat)
          let marker = new that.AMap.Marker({
            position: position,
            offset: new that.AMap.Pixel(-8, -17),
            icon: CameraIcon,
            label: {
              direction: 'bottom',
              content: camera.name,
            }
          })
          that.map.add(marker)
        }
      })
    },
    loadGrounds () {
      let that = this
      this.grounds = []
      requestService.get('/ground/listPage?pageSize=65535', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.grounds = res.data.body.records
        if (!that.grounds || that.grounds.length === 0) {
          return
        }
        let lng = 0
        let lat = 0
        let count = 0
        for (let ground of that.grounds) {
          if (!ground.gis && ground.gis !== '') {
            continue
          }
          let gis = JSON.parse(ground.gis)
          if (gis.length < 3) {
            continue
          }
          that.addPolygon([].concat(gis), '#000099')
          for (let item of gis) {
            lng = lng + item[0]
            lat = lat + item[1]
            count = count + 1
          }
        }
        if (count === 0) {
          return
        }
        lng = lng / count
        lat = lat / count
        if (that.map) {
          that.map.setCenter([lng, lat])
        }
      })
    },
    addPolygon (data, areaColor) {
      let that = this
      if (!data) {
        return
      }
      if (data.length < 3) {
        return
      }
      data.push(data[0])
      // let polygon = new that.AMap.Polygon({
      //   path: data,
      //   fillColor: areaColor,
      //   strokeOpacity: 1,
      //   fillOpacity: 0.5,
      //   strokeColor: '#2b8cbe',
      //   strokeWeight: 1,
      //   strokeStyle: 'dashed',
      //   strokeDasharray: [5, 5]
      // })
      // that.map.add(polygon)

      var polyline = new AMap.Polyline({
        path: data,
        isOutline: true,
        outlineColor: '#ffeeff',
        borderWeight: 3,
        strokeColor: "#3366FF",
        strokeOpacity: 1,
        strokeWeight: 6,
        strokeStyle: "dashed",
        strokeDasharray: [15, 5],
        lineJoin: 'round',
        lineCap: 'round',
        zIndex: 50,
      })
      that.map.add(polyline)   
    },
    initAMap () {
      let that = this
      AMapLoader.load({
        key: 'b72c573a626158a27e4ada7a9c853665',
        version: '1.4.15',
        plugins: ['AMap.Driving', 'AMap.MapType']
      }).then((AMap) => {
        that.AMap = AMap
        that.map = new AMap.Map('container', {
          zoom: 17,
          zooms: [2, 22],
          layers: [
            new AMap.TileLayer.Satellite()
          ]
        })
        that.loadGrounds()
        that.loadDeviceInstantiationGroups()
        
        // 监听地图点击事件
        AMap.event.addListener(that.map, 'click', function() {
          that.infoWindow.close();
        })
      }).catch(e => {
        console.log(e)
      })
    },
    timeRefreshDevices () {
      let that = this
      if (!this.deviceInstantiationGroup) {
        return
      }
      this.map.clearMap()

      if (this.grounds && this.grounds.length > 0) {
        let lng = 0
        let lat = 0
        let count = 0
        for (let ground of this.grounds) {
          if (!ground.gis && ground.gis !== '') {
            continue
          }
          let gis = JSON.parse(ground.gis)
          if (gis.length < 3) {
            continue
          }
          this.addPolygon([].concat(gis), '#000099')
          for (let item of gis) {
            lng = lng + item[0]
            lat = lat + item[1]
            count = count + 1
          }
        }
        if (count > 0) {
          lng = lng / count
          lat = lat / count
          if (this.map) {
            this.map.setCenter([lng, lat])
          }
        }
      }

      if (this.cameras && this.cameras.length > 0) {
        for (let camera of this.cameras) {
          if (!camera.lng || !camera.lat) {
            continue
          }
          let position = new that.AMap.LngLat(camera.lng, camera.lat)
          let marker = new that.AMap.Marker({
            position: position,
            offset: new that.AMap.Pixel(-8, -17),
            icon: CameraIcon
          })
          that.map.add(marker)
        }
      }

      this.loadDeviceInstantiations(this.deviceInstantiationGroup.id)
    },
    chart_init (xData, yData1) {
      this.chart.setOption({
        toolbox: {
          show: false
        },
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          show: false
        },
        grid: {
          top: '6%',
          right: '6%',
          bottom: '5%',
          left: '2%',
          containLabel: true,
          show: false
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: '#FFFFFF',
              fontSize: 16
            },
            data: xData
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#FFFFFF',
              fontSize: 16
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '数据',
            type: 'line',
            itemStyle: {
              color: '#0BE2F7'
            },
            lineStyle: {
              width: 4
            },
            smooth: true,
            data: yData1
          }
        ]
      })
    },
    timeRefreshCameraAccessToken () {
      let that = this
      requestService.post('/camera/getAccessToken', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.cameraAccessToken = res.data.accessToken
        console.log(res.data.accessToken)
      })
    },
    timeRefresh () {
      this.timeStr = this.formatDate(new Date())
    },
    jumpManage () {
      this.$router.replace('/org-manage')
    },
    formatDate (time, format) {
      var date = new Date(time)
      return formatDate(date, !format?'yyyy-MM-dd hh:mm:ss':format)
    }
  }
}
</script>

<style scoped>
@import '../../assets/dataV/dataV.css';
</style>



// WEBPACK FOOTER //
// src/components/dataV/index.vue